export { EloStarUnselectedIcon } from './star-unselected-icon'
